import axios from 'axios'
export const http = axios.create({
    baseURL: 'https://site.sagresimoveis.com.br',
    headers: {
        Accept: 'application/json'
    }
})
